import { exchangeRate } from "./constants";

export const calculateBuyValues = (rate, baseData) => {
  const buyValue = rate.ContractBuy?.Value ?? 0;
  const buyTotal = rate.ContractBuy?.Total ?? 0; //buyTotal = buyValue + buyTax
  const buyTax = rate.ContractBuy?.Tax ?? 0;
  const paxCount = rate?.PaxCount ?? 0;
  const qty = rate?.Quantity ?? 0;
  const unitCount = baseData?.UnitCount ?? 0;

  return {
    buyRate: (buyTotal).toFixed(2),
    buyTotalWithoutTax: (((buyValue * paxCount) * unitCount) * qty).toFixed(2),
    buyTotalWithTax: (((buyTotal * paxCount) * unitCount) * qty).toFixed(2),
    buyTax: (((buyTax * paxCount) * unitCount) * qty).toFixed(2),
  };
};

export const calculateSellValues = (rate, baseData, baseItemTypeData, clientCurrency) => {
  const sellTax = rate.ClientNetSell?.Tax ?? 0;
  const sellValue = rate.ClientNetSell?.Value ?? 0;
  const sellTotal = rate.ClientNetSell?.Total ?? 0; //sellTotal = sellValue + sellTax
  const paxCount = rate?.PaxCount ?? 0;
  const unitCount = baseData?.UnitCount ?? 0;
  const buyValue = rate.ContractBuy?.Value ?? 0;
  const qty = rate?.Quantity ?? 0;
  const markupRate = rate?.MarkupRate ?? 0;

  return {
    sellCurr: clientCurrency,

    buyTotalInSell: baseItemTypeData?.ContractCurrency === exchangeRate.ContractCurrency
      ? ((((buyValue * paxCount) * unitCount) * qty) * baseItemTypeData?.ExchangeRates?.ContractToSystem).toFixed(2)
      : ((((buyValue * paxCount) * unitCount) * qty) * baseItemTypeData?.ExchangeRates?.ContractToClient).toFixed(2),

    netSellRate: baseItemTypeData?.ContractCurrency === exchangeRate.ContractCurrency
      ? ((((sellValue * paxCount) * unitCount) * qty) * baseItemTypeData?.ExchangeRates?.ContractToSystem).toFixed(2)
      : ((((sellValue * paxCount) * unitCount) * qty) * baseItemTypeData?.ExchangeRates?.ContractToClient).toFixed(2),

    netSellTax: baseItemTypeData?.ContractCurrency === exchangeRate.ContractCurrency
      ? ((((sellTax * paxCount) * unitCount) * qty) * baseItemTypeData?.ExchangeRates?.ContractToSystem).toFixed(2)
      : ((((sellTax * paxCount) * unitCount) * qty) * baseItemTypeData?.ExchangeRates?.ContractToClient).toFixed(2),

    netSellTotal: baseItemTypeData?.ContractCurrency === exchangeRate.ContractCurrency
      ? (((sellTotal * paxCount * unitCount * qty)) * baseItemTypeData?.ExchangeRates?.ContractToSystem).toFixed(2)
      : (((sellTotal * paxCount * unitCount * qty)) * baseItemTypeData?.ExchangeRates?.ContractToClient).toFixed(2),

    markupRate: (markupRate).toFixed(2),
  };
};

export const calculateMarkupPercent = (value) => {
  const markup = value ?? 0;
  return markup.toFixed(2);
};

export const calculateExchangeRates = (contractRate, systemRate) => {
  return {
    contractToSystemRate: contractRate?.toFixed(2) ?? 'N/A',
    systemToClientRate: systemRate ?? 'N/A',
  };
};

export const getBaseRowData = (rate, baseData) => {
  return {
    description: rate.Name || baseData.RoomName || baseData.ServiceUnitName || 'N/A',
    paxPerUnit: rate.PaxCount ?? baseData.Adults ?? 0,
    rateId: rate.RateId ?? 0,
    roomCount: baseData.UnitCount ?? 1,
    chargeType: rate.ChargeType ?? 'Per Night',
    qty: rate.Quantity ?? 0,
  };
};

export const formatDateRange = (fromDate, toDate, parseDate, dateFormat) => {
  return {
    fromDate: fromDate ? parseDate(fromDate)?.format(dateFormat) : 'N/A',
    toDate: toDate ? parseDate(toDate)?.format(dateFormat) : 'N/A',
  };
};

export const createRateRow = (
  rate,
  reservationOverview,
  baseData,
  baseItemTypeData, // hotelData or serviceData
  group,
  item,
  type,
  roomRateType,
  parseDate,
  dateFormat,
  targetId
) => {
  const baseRowData = getBaseRowData(rate, baseData);
  const buyValues = calculateBuyValues(rate, baseData);
  const sellValues = calculateSellValues(rate, baseData, baseItemTypeData, reservationOverview.ClientCurrency);
  const dateRange = formatDateRange(rate.FromDate, rate.ThroughDate, parseDate, dateFormat);
  const markupPercent = calculateMarkupPercent(rate.MarkupRate);

  return {
    group,
    item,
    baseData,
    baseItemTypeData,
    type,
    targetId: String(targetId),
    roomRateType,
    ...baseRowData,
    ...dateRange,
    buyCurrency: baseItemTypeData?.ContractCurrency,
    sellCurrency: reservationOverview.ClientCurrency,
    ...buyValues,
    ...calculateExchangeRates(baseItemTypeData.ExchangeRates.ContractToSystem, baseItemTypeData.ExchangeRates.SystemToClient),
    ...sellValues,
    markupPercent,
  };
};